import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Root shell for the CRM internal app — purely a router host. The
 * lazy-loaded `/design-system` route (see `app.routes.ts`) is the
 * default landing until the dashboard ships in EBT-66+.
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class AppComponent {}
